export default "__VITE_ASSET__CGUUwr4S__"